import type { SVGProps } from "react";

export function IconDarkPurpleChartBars(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.125 4.125V28.875H28.875M17.875 8.9375V22M11 15.125V22M24.75 4.125V22"
        stroke="#3E2247"
        strokeWidth="2.0625"
        strokeLinecap="square"
      />
    </svg>
  );
}
